import apiClient from './api';

export const getQueueMetrics = async (hours = 24) => {
  const response = await apiClient.get(`/api/metrics/queue?hours=${hours}`);
  return response.data;
};
